export const columns = [
  {
    accessorKey: "registrationNumber",
    header: "Vehicle Number",
  },
  {
    accessorKey: "name",
    header: "Name",
  },
  {
    accessorKey: "itemName",
    header: "Other Inventory Item",
  },
  {
    accessorKey: "containerNumber",
    header: "Continer Number",
  },
  {
    accessorKey: "foundPackages",
    header: "Found Packages",
  },
  {
    accessorKey: "foundCBM",
    header: "Found CBM",
  },
  {
    accessorKey: "itemCode",
    header: "Item Code",
  },
  {
    accessorKey: "weight",
    header: "Weight",
  },
  {
    accessorKey: "entryReason",
    header: "Entry Reason",
  },
  {
    accessorKey: "actionButtons",
    header: "Action",
    accessorFn: (row: any) => ` ${row.actionButtons || " "}`,
    size: 200,
  },
];
